import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowCurveLeftDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.914 19.8 3.6 14.486m0 0 5.314-5.314M3.6 14.486h12.8a4 4 0 0 0 4-4V4.2"
    />
  </svg>
);
export default SvgArrowCurveLeftDown;
